import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const totalSurveyAttemptPublisherAction = createAsyncThunk(
    'total-survey-attempt',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/total-survey-attempt`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const tatolSurveryAttemptPublisherSlice = createSlice({
    name: 'total-survey-attempt',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(totalSurveyAttemptPublisherAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(totalSurveyAttemptPublisherAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(totalSurveyAttemptPublisherAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const totalSurveyAttemptPublisherReducer = tatolSurveryAttemptPublisherSlice.reducer